import React, { useEffect, useState } from 'react';
import { useForm} from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { MenuItem,
          TextField,
          Tooltip 
} from '@material-ui/core';

import { startOfWeek, 
          endOfWeek, 
          format, 
          addDays, 
          startOfMonth, 
          endOfMonth, 
          isSameMonth
} from "date-fns";

import es from 'date-fns/locale/es';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import PreviousProgramService from "../../services/previous-program.service";

import '../../styles/previousProgramStyle.scss';

import { monthCalendar } from '../../constants/models/monthCalendar';

import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import UsersService from '../../services/users.service';

export const PreviousProgramScreen = () => {

  const { isLoggedIn, user } = useSelector( state => state.auth); 
  const an8Logged = isLoggedIn? user.noCustomer:'---';

  const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
  const sessionDifference = timeSessionDifference();

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const [customers, setCustomers] = useState([]);

  const [years, setYears] = useState([]);

  const [months, setMonths] = useState([]);


  const [contentCompany, setContentCompany] = useState([{
    id: '',
    nombre: '',
    codigo:''
  }]);

  const [contentRetirement, setContentRetirement] = useState([{
    id: '',
    nombre: '',
    codigo:''
  }]);

  const [contentCement, setContentCement] = useState([]);

  const [contentFilters, setContentFilters] = useState({
    an8: '',
    company: '',
    cement: '',
    clientName: '',
    month: '',
    retirement:'',
    year: ''
  });

  const [contentFiltersResponse, setContentFiltersResponse] = useState([{
    id: 0,
    dia: 0,
    cantidad: []
  }]);

  const defaultFilter = {}

  const [isDisabledFilters, setIsDisabledFilters] = useState({
    company: true,
    cement: true,
    month: true,
    retirement:true,
    year: true,
    an8: true,
  });

  const [isLoadingFilters, setIsLoadingFilters] = useState(false);

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [errorResponse, setErrorResponse] = useState('');
  const [isErrorResponse, setIsErrorResponse] = useState(false);

  const {
    register,
    handleSubmit,
    reset
  } = useForm({defaultValues: defaultFilter});

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    getCustomers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const getCustomers = () =>{
    setIsLoadingFilters(true);

    UsersService.getCustomerAssociatesByAN8(an8Logged).then((response)=>{
      let customersResponse = response;
        
      setCustomers(customersResponse);
      setIsLoadingFilters(false);
    }).catch((error)=>{
      console.log(error);
      setCustomers([]);
      setIsLoadingFilters(false);
      
      if(sessionDifference > Number(tokenExpired)){
        sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar clientes.');
      }
    });
  }

  /**
   * Recupera la lista de años asociados a un cliente seleccionado
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
  const onCustomerChange = (data) =>{
    if (data.target.value || (Number(data.target.value.length) !== 0)) {

      setYears([]);
      setMonths([]);
      setContentCompany([]);
      setContentRetirement([]);
      setContentCement([]);

      setIsLoadingFilters(true);
      setIsDisabledFilters({...isDisabledFilters, an8:false, year: true, month: true, company: true,retirement: true, cement:true});

      setContentFilters({...contentFilters, an8: data.target.value, year: '', month: '', company: '', retirement: '', cement:''});

      reset(contentFilters);

      PreviousProgramService.getYears(data.target.value).then((response)=>{
        setYears(response);
        setIsLoadingFilters(false);
      }).catch((error)=>{
        console.log(error);
        setYears([]);
        setIsLoadingFilters(false);
        
        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al recuperar año.');
        }
      });
  } else {
    setIsDisabledFilters({...isDisabledFilters, an8: true, year: true, month: true, company: true,retirement: true, cement:true});
  }
  }

  const onYearChange = (data) => {

    if (data.target.value || (Number(data.target.value.length) !== 0)) {

      setMonths([]);
      setContentCompany([]);
      setContentRetirement([]);
      setContentCement([]);

      setIsLoadingFilters(true);
      setIsDisabledFilters({...isDisabledFilters, year: false, month: true, company: true,retirement: true, cement:true});

      setContentFilters({...contentFilters, year: data.target.value, month: '', company: '', retirement: '', cement:''});

      reset(contentFilters);

      PreviousProgramService.getMonth(contentFilters.an8, data.target.value).then((response)=>{
        setMonths(response);
        setIsLoadingFilters(false);
      }).catch((error)=>{
        console.log('Error mes');
        setMonths([]);
        setIsLoadingFilters(false);

        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al recuperar mes.');
        }
        
      });
    } else {
      setIsDisabledFilters({...isDisabledFilters, month: false, company: true,retirement: true, cement:true});
    }
  }

  const onMonthChange = (data) => {

    if (data.target.value || (Number(data.target.value.length) !== 0)) {

      setContentCompany([]);
      setContentRetirement([]);
      setContentCement([]);

      setIsLoadingFilters(true);

      setIsDisabledFilters({...isDisabledFilters, month: false, company: true,retirement: true, cement:true});

      const numberMount = monthCalendar.filter(monthRef => monthRef.name.toUpperCase() === data.target.value)[0].numberMount;

      setContentFilters({...contentFilters, month: numberMount, company: '', retirement: '', cement:''});

      reset(contentFilters);
      
      PreviousProgramService.getCompany(contentFilters.an8, contentFilters.year, numberMount).then((response)=>{
        setContentCompany(response);
        setIsLoadingFilters(false);
      }).catch((error)=>{
          setContentCompany([]);
          setIsLoadingFilters(false);

        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          actionErrorConnection(error, 'Error al recuperar planta.');
        }
      });
      
    } else {
      setIsDisabledFilters({...isDisabledFilters, month: true, company: true,retirement: true, cement:true});
    }
  }

  const onCompanyChange = (data) => {

    if (data.target.value || (Number(data.target.value.length) !== 0)) {

      setContentRetirement([]);
      setContentCement([]);

      setIsLoadingFilters(true);

      setIsDisabledFilters({...isDisabledFilters, company: false, retirement: true, cement:true});

      setContentFilters({...contentFilters, company: data.target.value.trim(), retirement: '', cement:''});

      reset(contentFilters);
      
      PreviousProgramService.getRetirement(contentFilters.an8, contentFilters.year, contentFilters.month, data.target.value.trim()).then((response)=>{
        setContentRetirement(response);
        setIsLoadingFilters(false);
      }).catch((error)=>{
        setContentRetirement([]);
        setIsLoadingFilters(false);

        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar forma de retiro.');
        }
      });

      
    } else {
      setIsDisabledFilters({...isDisabledFilters, company: true,retirement: true, cement:true});
    }
  }

  const onRetirementChange = (data) => {

    if (data.target.value || (Number(data.target.value.length) !== 0)) {

      setContentCement([]);

      setIsLoadingFilters(true);

      setIsDisabledFilters({...isDisabledFilters, retirement: false, cement:true});

      setContentFilters({...contentFilters, retirement: data.target.value, cement:''});

      reset(contentFilters);
      
      PreviousProgramService.getCement(contentFilters.an8, contentFilters.year, contentFilters.month, contentFilters.company, data.target.value).then((response)=>{
        setContentCement(response);
        setIsLoadingFilters(false);
      }).catch((error)=>{
          setContentCement([]);
          setIsLoadingFilters(false);

        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
      } else{
        actionErrorConnection(error, 'Error al recuperar tipo cemento.');
        }
      });
    } else {
      setIsDisabledFilters({...isDisabledFilters, retirement: true, cement:true});
    }
  }

  const onCementChange = (data) => {
    if (data.target.value || (Number(data.target.value.length) !== 0)) {
      setIsDisabledFilters({...isDisabledFilters, cement: false});
      setContentFilters({...contentFilters, cement: data.target.value});
    } else {
      setIsDisabledFilters({...isDisabledFilters, cement: true});
    }
  }

  const onSubmit = () => {
    setContentFiltersResponse([]);
    setIsLoadingData(true);

    PreviousProgramService.getPreviousProgramByFilters(
      contentFilters.an8, contentFilters.year, contentFilters.month, contentFilters.company, contentFilters.retirement, contentFilters.cement).then((response)=>{
        setContentFiltersResponse(response);
        const mounthReference = monthCalendar.filter( reference => Number(reference.numberMount) === Number(contentFilters.month));
        setCurrentMonth(new Date(`${mounthReference[0].reference} 01 ${contentFilters.year}`));
        setIsLoadingData(false);

      }).catch((error)=>{

        if(sessionDifference > Number(tokenExpired)){
          sesionExpired(dispatch, history);
        } else{
          
            if(error.response){
              setErrorResponse(error.response.data.mensaje);
            } else{
              setErrorResponse(error);
              actionErrorConnection(error);
            }
            setIsErrorResponse(true);

            setIsLoadingData(false);
        }
      });
  }

  const renderDays = () => {
    const dateFormat = "EEEE";
    const days = [];
    let startDate = startOfWeek(currentMonth);
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          {format(addDays(startDate, i), dateFormat, {locale: es})}
        </div>
      );
    }
    return <div className="days row">{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);

    const dateFormat = "d";
    const rows = [];

    let days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        let formattedDate = format(day, dateFormat);
        let orderFilter = contentFiltersResponse.filter( orderResponse =>
           orderResponse.day.toString() === formattedDate);

        days.push(
          <div
            className={`col cell ${
              !isSameMonth(day, monthStart)
                ? "disabled "
                :  ""
            } p-0`} style={{height: 6+'em'}}
            key={day}
          >
            <span className="number">{formattedDate}</span>
            
            <div className="p-0 mt-4 pt-2 d-flex justify-content-center">
              <ul className="list-elements list-element-order">

              {(!orderFilter.length>0 && !isSameMonth(day, monthStart)) && <li >0</li> }
              {orderFilter.length>0 && isSameMonth(day, monthStart) && <li> {orderFilter[0].amount} </li> }
              </ul>
            </div>
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }

    return <div className="body">{rows}</div>;
  };

  const renderFilters = () => {

    const tooltipTitle = (filter, disabledFilter, name) =>{
      let title = '';
      title = filter.length>0 && !disabledFilter ? '' : name;
      return title;
    } 

    const renderNoDataFilter = (filter) =>{
      return (
        <>
          {filter.length === 0 && <MenuItem value="">Sin registros</MenuItem>}
        </>
      )
    }

    return(
      <>
        <div className="filter-continer">
          <div className="container mt-3">
            <form className="row">
              {/* --- AN8--- */}
              <div className="col-md-5 col-lg-4 mb-3">
                <TextField
                  select
                  required
                  id="an8"
                  name="an8"
                  label="Num. cliente"
                  variant="outlined"
                  size="small" 
                  fullWidth
                  disabled={isLoadingFilters}
                  defaultValue={''}
                  {...register('an8')}
                  onBlur={onCustomerChange}
                  >
                    <MenuItem value="">Seleccionar cliente</MenuItem>
                    {customers.map(({noCustomer, name}) => (
                        <MenuItem key={noCustomer} value={noCustomer}>
                        {noCustomer} - {name}
                        </MenuItem>
                    ))}
                    {renderNoDataFilter(customers)}
                </TextField>
              </div>
              {/* --- AÑO --- */}
              <div className="col-md-5 col-lg-4 mb-3">
              <TextField
                  select
                  required
                  id="year"
                  name="year"
                  label="Año"
                  variant="outlined"
                  size="small" 
                  fullWidth
                  disabled={(customers.length>0 && !isDisabledFilters.an8 && !isLoadingFilters)?false:true}
                  defaultValue={''}
                  {...register('year')}
                  onBlur={onYearChange}
                  >
                      <MenuItem value="">Seleccionar año</MenuItem>
                      {renderNoDataFilter(years)}
                  {years.map((year) => (
                      <MenuItem key={year} value={year}>
                      {year}
                      </MenuItem>
                  ))}
                </TextField>
              </div>
              {/* --- MES --- */}
              <div className="col-md-5 col-lg-4 mb-3">
                <Tooltip title={tooltipTitle(years,isDisabledFilters.year,'seleccionar año')} placement="top-start" arrow>
                  <TextField
                    select
                    required
                    id="month"
                    name="month"
                    label="Mes"
                    variant="outlined"
                    size="small" 
                    fullWidth
                    disabled={(years.length>0 && !isDisabledFilters.year && !isLoadingFilters)?false:true}
                    {...register('month')}
                    defaultValue={""}
                    onBlur={onMonthChange}
                    >
                        <MenuItem value="">Seleccionar mes</MenuItem>
                        {renderNoDataFilter(months)}
                    {months.map((option) => (
                        <MenuItem key={option} value={option}>
                        {option}
                        </MenuItem>
                    ))}
                  </TextField>
                </Tooltip>
              </div>
              {/* --- PLANTA --- */}
              <div className="col-md-5 col-lg-4 mb-3">
                <Tooltip title={tooltipTitle(months,isDisabledFilters.month,'seleccionar mes')} placement="top-start" arrow>
                  <TextField
                    select
                    required
                    id="company"
                    name="company"
                    label="Planta"
                    variant="outlined"
                    size="small" 
                    fullWidth
                    disabled={(months.length>0 && !isDisabledFilters.month && !isLoadingFilters)?false:true}
                    defaultValue={''}
                    {...register('company')}
                    onBlur={onCompanyChange}
                    >
                        <MenuItem value="">Seleccionar planta</MenuItem>
                        {renderNoDataFilter(contentCompany)}
                    {contentCompany.map((option, index) => (
                        <MenuItem key={index} value={option.codigo.trim()}>
                        {option.nombre}
                        </MenuItem>
                    ))}
                  </TextField>
                </Tooltip>
              </div>
              {/* --- PAGO --- */}
              <div className="col-md-5 col-lg-4 mb-3">
                <Tooltip title={tooltipTitle(contentCompany,isDisabledFilters.company,'seleccionar planta')} placement="top-start" arrow>
                  <TextField
                    select
                    required
                    id="retirement"
                    name="retirement"
                    label="Forma de Retiro"
                    variant="outlined"
                    size="small" 
                    fullWidth
                    disabled={(contentCompany.length>0 && !isDisabledFilters.company && !isLoadingFilters)?false:true}
                    defaultValue={''}
                    {...register('retirement')}
                    onBlur={onRetirementChange}
                    >
                        <MenuItem value="">Seleccionar forma</MenuItem>
                        {renderNoDataFilter(contentRetirement)}
                      {contentRetirement.map((option, index) => (
                          <MenuItem key={index} value={option.nombre.trim()}>
                          {option.codigo}
                          </MenuItem>
                      ))}
                  </TextField>
                </Tooltip>
              </div>
              {/* --- CEMENTO --- */}
              <div className="col-md-5 col-lg-4 mb-3">
                <Tooltip title={tooltipTitle(contentRetirement,isDisabledFilters.retirement,'seleccionar forma de retiro')} placement="top-start" arrow>
                  <TextField
                    select
                    required
                    id="cement"
                    name="cement"
                    label="Tipo de cemento"
                    variant="outlined"
                    size="small" 
                    fullWidth
                    disabled={(contentRetirement.length>0 && !isDisabledFilters.retirement && !isLoadingFilters)?false:true}
                    defaultValue={''}
                    {...register('cement')}
                    onBlur={onCementChange}
                    >
                        <MenuItem value="">Seleccionar cemento</MenuItem>
                        {renderNoDataFilter(contentCement)}
                      {contentCement.map((option) => (
                          <MenuItem key={option} value={option.trim()}>
                          {option}
                          </MenuItem>
                      ))}
                  </TextField>
                </Tooltip>
              </div>
              {/* --- SUBMIT--- */}
              <div className="col-12 w-100 d-flex justify-content-end">
                <Tooltip title={isDisabledFilters.retirement ? "Completar filtros obligatorios":"Buscar"} placement="top-start" arrow>
                  <div>
                    <button 
                      className="ms-2 mb-3 btn custom-btn"
                      data-bs-toggle="collapse" 
                      data-bs-target="#collapseExample" 
                      aria-expanded="false" 
                      aria-controls="collapseExample"
                      disabled={isDisabledFilters.cement}
                      onClick={handleSubmit(onSubmit)}
                      type='submit'
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </Tooltip>
              </div>
          </form>
          </div>
        </div>
      </>
    )
  };

  const renderFiltersData = () => {
    return (
    <>
      <div className="col-md-12">
        <span className="calendar-text-header-title">Cliente: </span>
        <span className="calendar-text-header-title ms-2">{customers.find(customer => customer.noCustomer === contentFilters.an8)?.name } - {contentFilters.an8}</span>
      </div>
      <div className="col-md-6">
        <div className=" row">
          <div className="col-6 col-md-5">
          <span className="calendar-text-header-title">Año:</span>
          </div>
          <div className="col-6 col-md-7">
          <span className="calendar-text-header-info">{contentFilters.year?contentFilters.year:'---'}</span>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className=" row">
          <div className="col-6 col-md-5">
          <span className="calendar-text-header-title">Mes:</span>
          </div>
          <div className="col-6 col-md-7">
          <span className="calendar-text-header-info">{contentFilters.month ? monthCalendar.filter(monthRef => Number(monthRef.numberMount) === Number(contentFilters.month))[0].name?.toUpperCase(): '---'}</span>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className=" row">
          <div className="col-6 col-md-5">
          <span className="calendar-text-header-title">Planta:</span>
          </div>
          <div className="col-6 col-md-7">
          <span className="calendar-text-header-info">{contentFilters.company && contentCompany.length>0 ? contentCompany.filter(companyRef=> companyRef.codigo.trim() === contentFilters.company)[0].nombre : '---'}</span>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className=" row">
          <div className="col-6 col-md-5">
          <span className="calendar-text-header-title">Forma de Retiro:</span>
          </div>
          <div className="col-6 col-md-7">
          <span className="calendar-text-header-info">{contentFilters.retirement && contentRetirement.length>0 ? contentRetirement.filter(retirementRef => retirementRef.nombre.trim() === contentFilters.retirement)[0].codigo.toUpperCase() : '---'}</span>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className=" row">
          <div className="col-6 col-md-5">
          <span className="calendar-text-header-title">Cemento:</span>
          </div>
          <div className="col-6 col-md-7">
          <span className="calendar-text-header-info">{contentFilters.cement ? contentFilters.cement : '---'}</span>
          </div>
        </div>
      </div>                          
    </>
    )
  };

    return (
        <>
          <div className="container-fluid p-0 m-0">
            <div className="row flex-nowrap p-0 m-0">
                <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                <SidebarMenu/>
                </div>
                <div className="col p-0 ms-1 me-1">
                <NavTopMenu />


                <div className="container ps-3 pe-3 container-size">
                  <div className="row base-container ">
                    <div>
                    <div className="col-12 border-title text-title pt-2 pb-2 ps-4">
                      <span className="h4">Programa Previo</span>
                    </div>
                  
                    <div className="col-12 pt-1 pb-3 ps-2 pe-2">
                        <div className="row ">
                            <div className="col-12 ">
                            <div className="w-100 d-flex justify-content-end">
                            {isLoadingFilters && 
                              <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                                <div className="custom-icon-loading me-1">
                                  <i className="fas fa-spinner fa-spin"></i>
                                </div>
                              </Tooltip>
                            }
                            <Tooltip title="Filtrar" placement="top-start" arrow>
                              <button className="btn custom-btn-icons" 
                              type="button" data-bs-toggle="collapse" 
                              data-bs-target="#collapseExample" aria-expanded="false" 
                              aria-controls="collapseExample">
                                <i className="fas fa-filter"></i>
                              </button>
                            </Tooltip>
                            </div>
                            <div className="collapse show" id="collapseExample">
                              {renderFilters()}
                            </div>
                                
                            </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="calendar">
                              <div className=" row pt-3 pb-3">
                                {renderFiltersData()}
                              </div>
                              <div className="row">
                                <div 
                                    className={`col-12 loading-continer 
                                        ${ isLoadingData || isErrorResponse ? 'd-block' : 'd-none'}`}>
                                  <div className="w-100 d-flex justify-content-center">
                                    {(isErrorResponse) &&
                                      <span className="custom-error-text">{errorResponse.toString()}</span>
                                    }
                                    {isLoadingData && <span className="custom-icon-loading"><i className="fas fa-spinner fa-spin"></i></span>}
                                  </div>
                                </div>
                              </div>
                              {(!isErrorResponse && contentFiltersResponse.length > 27 ) && renderDays()}
                              {(!isErrorResponse && contentFiltersResponse.length > 27 ) && renderCells()}
                            </div>
                          </div>
                        </div>

                    </div>
                      
                    </div>

                  </div>
                </div>

                </div>
            </div>
          </div>
        
           
            <Footer/>
        </>
    )
}
